import React, {  } from "react";

import {
  Card
} from '@lockerpm/design';

import commonComponents from "../../../components/common";

import images from "../../../assets/images";

const AuthCard = (props) => {
  const { AuthLogo } = commonComponents;
  const { AuthBgImage } = images;

  const {
    className = '',
    paddingTop = 62,
    cardWidth = 430,
    top = <></>,
    children = <></>,
    other = <></>
  } = props;

  return (
    <div
      className={`auth-card flex justify-center ${className}`}
      style={{
        backgroundImage: `url(${AuthBgImage})`,
        backgroundRepeat: 'no-repeat',
        paddingTop: paddingTop,
        backgroundSize: 'contain'
      }}
    >
      <div style={{ width: cardWidth }}>
        {top}
        <AuthLogo
          className={'mb-8'}
        />
        <div className="flex items-center justify-center">
          <Card
            className="w-full"
            style={{
              boxShadow: 'none'
            }}
            bodyStyle={{
              padding: 24
            }}
          >
            {children}
          </Card>
        </div>
        {other}
      </div>
    </div>
  );
}

export default AuthCard;